<template>
  <div>
    <div class="main" v-if="isPC">
      <p class="page-title">{{ $t('currency.accountSettings') }}</p>
      <div class="account-setting bg-white ">
        <el-form ref="accountForm" label-position="top" label-width="100px" :model="accountForm">
          <el-form-item :label="$t('PersonalCenter.AccountSetting.Index.FullName')" prop="fullName">
            <el-input v-model="accountForm.fullName" disabled style="width: 300px;" @blur="setFullName"></el-input>
            <el-button type="text" style="margin-left:20px" @click="handleUpdate('fullName')">{{$t('setting.update')}}</el-button>
          </el-form-item>
          <el-form-item :label="$t('PersonalCenter.AccountSetting.Index.Email')" prop="email">
            <el-input v-model="accountForm.email" disabled style="width: 300px;" :placeholder="$t('PersonalCenter.AccountSetting.Index.Email')"></el-input>
            <!-- <span class="not-verified pointer" @click="visible=true" v-show="!$store.state.common.isAuthentication">{{ $t('PersonalCenter.AccountSetting.Index.NotVerified') }}</span> -->
            <!-- 不需要邮箱验证 -->
            <!-- <span v-if="!$store.state.common.isAuthentication" class="not-verified pointer" @click="clickVerifiedEmail">{{$t('setting.notVerified')}}</span> -->

            <el-button v-if="!accountForm.email" type="text" style="margin-left:17px" @click="handleUpdate('email')">{{$t('setting.update')}}</el-button>
          </el-form-item>
          <el-form-item :label="$t('PersonalCenter.AccountSetting.Index.Phone')" prop="phone">
            <el-input v-model="accountForm.phone" :placeholder="$t('PersonalCenter.AccountSetting.Index.Phone')" disabled style="width: 300px;"></el-input>
            <el-button v-if="!accountForm.phone" type="text" style="margin-left:20px" @click="handleUpdate('phone')">{{$t('setting.update')}}</el-button>
          </el-form-item>
          <el-form-item :label="$t('PersonalCenter.AccountSetting.Index.Password')">
            <span style="width: 260px;">********</span> <span class="change pointer" @click="$refs.accountChangePassword.toggle(accountForm)">{{$t('setting.update')}}</span>
          </el-form-item>
        </el-form>
      </div>
      <!-- <div class="login-history bg-white ">
        <div class="f--c title">
          <h2>Devices</h2>
          <span>You're currently logged in to Kakaclo on these devices</span>
        </div>
        <div class="history f" v-for="(item,index) in historyInfo" :key="index">
          <div class="left-icon">
            <i class="iconfont icon-computer-line" v-if="!item.equipmentType||item.equipmentType.indexOf('Windows')>-1"></i>
            <i class="iconfont icon-tablet-line" v-else></i>
          </div>
          <div class="right">
            <div class="device_name">{{item.equipmentType}}</div>
            <div class="info">IP：{{item.ipAddress}}；{{item.loginDate|dateFormat}}</div>
            <div class="info"> <i class="iconfont icon-diqiuquanqiu" v-show="item.loginAddress&&item.loginAddress!==''"></i> {{item.loginAddress}}</div>
          </div>
        </div>
      </div> -->
    </div>
    <div v-else class="account-setting_mobile">
      <div class="change-password_mobile bg-white" v-if="changePassword">
        <h2>{{ $t('PersonalCenter.AccountSetting.Index.ChangePassword') }}</h2>
        <p>{{ $t('PersonalCenter.AccountSetting.Index.Tips1') }}</p>
        <p style="padding-bottom:0.5rem">{{ accountForm.email }}</p>
        <el-form ref="accountForm" :model="accountForm" :rules="rules">
          <el-form-item prop="verificationCode" class="f">
            <el-input style="width:4.72rem;margin-right: 0.2rem;" :placeholder="$t('PersonalCenter.AccountSetting.Index.VerificationCode')" class="verificationCode-input" v-model.trim="accountForm.verificationCode"></el-input>
            <span class="pointer" @click="sendVertificationCode">
              <el-button class="send-button">{{ seconds===0?'Send':`${seconds}s` }}</el-button>
            </span>
            <p class="sendCodeTip" v-if="seconds===0">{{ $t('PersonalCenter.AccountSetting.Index.Tips2') }}</p>
            <p class="sendCodeTip" v-else>{{ $t('PersonalCenter.AccountSetting.Index.Tips3') }} <span style="color:#99C41C;">{{ seconds }}</span> {{ $t('PersonalCenter.AccountSetting.Index.later') }}</p>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password" :placeholder="$t('PersonalCenter.AccountSetting.Index.Password')" v-model.trim="accountForm.password" show-password></el-input>
          </el-form-item>
          <el-form-item prop="checkPassword">
            <el-input type="password" :placeholder="$t('PersonalCenter.AccountSetting.Index.ConfirmPassword')" v-model.trim="accountForm.checkPassword" show-password></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="submit-button" @click="handleModifyPassword">{{ $t('PersonalCenter.AccountSetting.Index.Submit') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="mail-certificate_mobile bg-white" v-else-if="certificateEmailShow">
        <h2>{{ $t('PersonalCenter.AccountSetting.Index.EMailVerification') }}</h2>
        <p>{{ $t('PersonalCenter.AccountSetting.Index.Tips1') }}</p>
        <p style="padding-bottom:0.5rem">{{ accountForm.email }}</p>
        <el-form ref="accountForm" :model="accountForm" :rules="rules">
          <el-form-item prop="verificationCode" class="f">
            <el-input style="width:4.72rem;margin-right: 0.2rem;" :placeholder="$t('PersonalCenter.AccountSetting.Index.VerificationCode')" class="verificationCode-input" v-model.trim="accountForm.verificationCode"></el-input>
            <span class="pointer" @click="sendVertificationCode">
              <el-button class="send-button">{{ seconds===0?'Send':`${seconds}s` }}</el-button>
            </span>
            <p class="sendCodeTip" v-if="seconds>0">{{ $t('PersonalCenter.AccountSetting.Index.Tips3') }} <span style="color:#99C41C;">{{ seconds }}</span> {{ $t('PersonalCenter.AccountSetting.Index.later') }}</p>
          </el-form-item>
          <el-form-item>
            <el-button class="submit-button" @click="submitCertificateUser">{{ $t('PersonalCenter.AccountSetting.Index.Submit') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="account-setting-mobile_main" v-else>
        <div class="part-main bg-white f-b">
          <span class="title">{{ $t('PersonalCenter.AccountSetting.Index.FullName') }}</span>
          <span class="content">{{ accountForm.fullName }}</span>
        </div>
        <div class="part-main bg-white f-b">
          <span class="title">{{ $t('PersonalCenter.AccountSetting.Index.Email') }}</span>
          <div>
            <div class="content">{{ accountForm.email }}</div>
            <span class="not-verified pointer" @click="certificateEmail" v-show="!$store.state.common.isAuthentication">{{ $t('PersonalCenter.AccountSetting.Index.NotVerified') }}</span>
          </div>
        </div>
        <div class="part-main bg-white f-b">
          <span class="title">{{ $t('PersonalCenter.AccountSetting.Index.Password') }}</span>
          <div>
            <div class="content">********</div>
            <!-- <span class="change pointer" @click="change">{{$t('setting.change')}}</span> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 设置账号密码 -->
    <AccountChangePassword ref="accountChangePassword"></AccountChangePassword>
    <!-- 设置账号 -->
    <AccountSetting ref="accountSetting" @setSuccess="setSuccess"></AccountSetting>
    <el-dialog :title="$t('PersonalCenter.AccountSetting.Index.EMailVerification')" :visible.sync="visible" :close-on-click-modal="false" width="600px">
      <p class="vertificate-tip">{{ $t('PersonalCenter.AccountSetting.Index.Tips4') }}</p>
      <p class="vertificate-tip">{{accountForm.email}}</p>
      <div class="f" style="margin-top:10px;">
        <span style="display:inline-block;line-height:36px;">{{ $t('PersonalCenter.AccountSetting.Index.VerificationCode') }}：</span>
        <div>
          <el-input v-model="verificationCode" style="width: 360px;">
            <template slot="append">
              <span :loading="loading" class="pointer" size="large" @click="sendVertificationCode" v-if="seconds===0">
                <el-button>{{ $t('PersonalCenter.AccountSetting.Index.Send') }}</el-button>
              </span>
            </template>
          </el-input>
          <p class="vertificate-tip" v-if="seconds>0">{{ $t('PersonalCenter.AccountSetting.Index.Tips3') }} <span style="color: #99C41C;">{{seconds}}</span>s {{ $t('PersonalCenter.AccountSetting.Index.later') }}</p>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel">{{$t('currency.cancel')}}</el-button>
        <el-button size="small" type="primary" @click="verificationUser">{{$t('currency.submit')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
import AccountChangePassword from './components/AccountChangePassword.vue'
import { encrypt } from '@/util/encryp.js'
import { pureNumber } from '@/util/validate'
import AccountSetting from './components/AccountSetting.vue'
let checkPureNumber = (rules, value, callback) => {
  if (pureNumber(value)) {
    callback()
  } else {
    callback(new Error(`${this.$t('PersonalCenter.AccountSetting.Index.Tips5')}`))
  }
}
export default {
  components: {
    AccountChangePassword,
    AccountSetting
  },
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(`${this.$t('PersonalCenter.AccountSetting.Index.Tips6')}`))
      } else if (value !== this.accountForm.password) {
        callback(new Error(`${this.$t('PersonalCenter.AccountSetting.Index.Tips7')}`))
      } else {
        callback()
      }
    }
    return {
      accountForm: {
        fullName: undefined,
        verificationCode: '',
        password: '',
        checkPassword: ''
      },
      verificationCode: '',
      visible: false,
      loading: false,
      changePassword: false,
      certificateEmailShow: false,
      seconds: 0,
      timer: null,
      historyInfo: [],
      rules: {
        verificationCode: [{ validate: checkPureNumber, trigger: 'blur' }, { required: true, message: '', trigger: ['change', 'blur'] }],
        password: [{ required: true, message: `${this.$t('PersonalCenter.AccountSetting.Index.Tips8')}`, trigger: ['change', 'blur'] }],
        checkPassword: [{ validator: validatePass2, trigger: 'blur' }, { required: true, message: '', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.accountForm.fullName = this.$store.state.common.userName
    this.accountForm.email = this.$store.state.common.email
    this.accountForm.phone = this.$store.state.common.phone
    // this.getLoginLogs()
  },
  methods: {
    handleModifyPassword() {
      this.$refs.accountForm.validate(valid => {
        if (!valid) return
        API.handleForgetPassword({
          email: this.$store.state.common.email,
          verificationCode: this.accountForm.verificationCode
        }).then(() => {
          API.handleModifyPassword({
            email: this.$store.state.common.email,
            password: encrypt(this.accountForm.password)
          }).then(res => {
            this.$message.success(this.$t('promptText.msg1'))
            this.visible = false
            this.accountForm.verificationCode = undefined
            this.accountForm.password = undefined
            this.accountForm.checkPassword = undefined
            this.changePassword = false
          }).catch(result => {
            this.$message.error(result.data.message)
          })
        }).catch(result => {
          this.$message.error(result.data.message)
        })
      })
    },
    submitCertificateUser() {
      this.$refs.accountForm.validate(valid => {
        if (!valid) return
        this.verificationUser()
      })
    },
    getLoginLogs() {
      API.getLoginLogs(this.$store.state.common.userId).then(res => {
        let timeNow = new Date().getTime()
        this.historyInfo = res.data.filter(item => { return item.loginDate > timeNow - 30 * 24 * 60 * 60 * 1000 })
      })
    },
    cancel() {
      this.visible = false
      this.verificationCode = ''
    },
    certificateEmail() {
      this.certificateEmailShow = true
      this.changePassword = false
    },
    sendVertificationCode() {
      this.loading = true
      API.sendVertificationCode({ email: this.accountForm.email }).then(() => {
        this.seconds = 60
        this.timer = setInterval(() => {
          if (this.seconds <= 0) {
            clearInterval(this.timer)
            this.timer = null
            this.$forceUpdate()
            return
          }
          console.log(this.timer)
          --this.seconds
        }, 1000)
      }).catch(result => {
        this.$message.error(result.data.message)
      }).finally(() => {
        this.loading = false
      })
    },
    verificationUser() {
      API.verificationUser({
        email: this.$store.state.common.email,
        verificationCode: this.verificationCode === '' ? this.accountForm.verificationCode : this.verificationCode
      }).then(result => {
        this.$message.success(this.$t('promptText.msg4'))
        this.$store.commit('common/set', {
          isAuthentication: true
        })
        this.accountForm.verificationCode = ''
        this.verificationCode = ''
      }).catch(result => {
        this.$message.error(result.data.message)
      })
    },
    change() {
      this.changePassword = true
      this.certificateEmailShow = false
    },
    // 更改账号名
    setFullName() {
      if (!this.accountForm.fullName) {
        this.accountForm.fullName = this.$store.state.common.userName
        this.$message.warning(this.$t('Home.Register.FullNameCheck1'))
        return
      }
      if (this.accountForm.fullName.length < 2 || this.accountForm.fullName.length > 255) {
        this.accountForm.fullName = this.$store.state.common.userName
        this.$message.warning(this.$t('Home.Register.FullNameCheck2'))
        return
      }
      API.accountSetting({
        fullName: this.accountForm.fullName,
        email: this.$store.state.common.email,
        userId: this.$store.state.common.userId
      }).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.$message.success(this.$t('common.success'))
        this.$store.commit('common/set', {
          userName: this.accountForm.fullName
        })
      })
    },
    handleUpdate(type) {
      this.$refs.accountSetting.show(type)
    },
    setSuccess() {
      location.reload()
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/.el-dialog__body {
  padding: 10px 20px;
}
.page-title {
  display: inline-block;
  font-size: 18px;
  line-height: 27px;
  font-weight: 600;
  padding-bottom: 10px;
  padding-left: 20px;
}
.account-setting {
  padding: 40px 0;
  padding-left: 30px;

  /deep/ .el-form-item__label {
    padding-bottom: 0;
  }
}
/deep/.el-input__inner {
  border-radius: 2px;
}
.change {
  color: #99c41c;
}
.not-verified {
  display: inline-block;
  width: 102px;
  height: 24px;
  color: #f4a963;
  text-align: center;
  line-height: 24px;
  border: 0.5px solid #f4a963;
  border-radius: 40px;
}
.vertificate-tip {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #747a87;
}
.login-history {
  margin-top: 5px;
  padding: 22px 32px;
  .title {
    padding-bottom: 27px;
    h2 {
      font-weight: 500;
      font-size: 18px;
      line-height: 27px;
      color: #000000;
      padding-right: 22px;
    }
    span {
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      color: #747a87;
    }
  }
  .history {
    margin-bottom: 28px;
    .left-icon {
      width: 23px;
      height: 23px;
      margin-right: 12px;
      i{
        font-size: 22px;
      }
    }
    .right {
      .device_name {
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: #10141d;
      }
      .info {
        font-weight: 400;
        font-size: 14px;
        line-height: 23px;
        color: #747a87!important;
      }
    }
  }
}

/deep/.el-input-group--append .el-input__inner {
  border-radius: 2px 0 0 2px;
  border-right: 0;
}
/deep/.el-input-group__append {
  background: #fff;
  border-left: 0;
  color: #99c41c;
}
.account-setting_mobile {
  h2 {
    font-weight: 600;
    font-size: 0.36rem;
    line-height: 0.54rem;
    color: #4f4f4f;
  }
  p {
    font-weight: 400;
    font-size: 0.28rem;
    line-height: 0.4rem;
    color: #747a87;
  }
  .sendCodeTip {
    font-weight: 400;
    font-size: 0.24rem;
    line-height: 0.36rem;
    color: #7b7b7b;
    margin-top: 0.28rem;
  }
  .mail-certificate_mobile {
    padding: 0.34rem 0.3rem;
    min-height: calc(100vh - 0.86rem);
  }
  .change-password_mobile {
    padding: 0.34rem 0.3rem;
    min-height: calc(100vh - 0.86rem);
  }
  .account-setting-mobile_main {
    .part-main {
      padding: 0.28rem 0.44rem;
      margin-top: 0.2rem;
      font-weight: 400;
      font-size: 0.28rem;
      line-height: 0.4rem;
      .title {
        color: #747a87;
      }
      .content {
        color: #10141d;
      }
    }
  }
  .verificationCode-input /deep/.el-input__inner {
    width: 4.72rem;
    border: 0.5px solid #b6b6b6;
  }
  /deep/.el-input__inner {
    height: 0.8rem;
    border-radius: 1.2rem;
  }
  .send-button {
    width: 1.9rem;
    height: 0.8rem;
    border: 0.5px solid #99c41c;
    border-radius: 1.2rem;
    color: #99c41c;
  }
  .submit-button {
    width: 100%;
    height: 0.92rem;
    background: #10141d;
    border-radius: 0.6rem;
    color: #fff;
    font-weight: 600;
    font-size: 0.32rem;
    line-height: 0.48rem;
    text-align: center;
  }
}
</style>
